import React, { useMemo } from 'react';
import { useStylesGlobal } from '../../pages/GlobalStyle.css';
import { Button, useTheme, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  primary: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.getContrastText(theme.palette.primary.main),
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  secondary: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.getContrastText(theme.palette.secondary.main),
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
}));

const ButtonStyled = ({ variant, color, style = {}, onClick, children, startIcon, size = 'large', disabled = false }) => {
  const theme = useTheme();
  const stylesGlobal = useStylesGlobal();
  const classes = useStyles(theme);

  const buttonClass = color && stylesGlobal[color] ? stylesGlobal[color] : color === 'secondary' ? classes.secondary : classes.primary;
  // Memoise appliedFontSizes based on size
  const appliedFontSizes = useMemo(() => {
    if (style.fontSize) return { fontSize: style.fontSize };
    if (size === 'medium') return { fontSize: '12px' };
    if (size === 'small') return { fontSize: '10px' };
    return {};
  }, [size, style]);

  // Combine all styles
  const combinedStyles = { ...style, ...appliedFontSizes };

  return (
    <Button variant={variant} className={buttonClass} style={combinedStyles} onClick={onClick} startIcon={startIcon} size={size} disabled={disabled} >
      {children}
    </Button>
  );
};

export default ButtonStyled;
